import LocationForAccountList from '@/components/LocationForAccount/LocationForAccountList'
import LocationForAccountDetail from '@/components/LocationForAccount/LocationForAccountDetail'

// Le suivi n'a ni création ni suppression : une demande naît en boutique, et se clôt par une
// transition de workflow — jamais par un effacement.
let LocationForAccountRouter = [{
  path: '/location-for-account',
  name: 'LocationForAccountList',
  component: LocationForAccountList,
  meta: {
    title: 'Suivi des locations pour compte',
    requiresAuth: true,
    authorizations: ['location-for-account_index', 'desktop_access']
  }
}, {
  path: '/location-for-account/:id',
  name: 'LocationForAccountDetail',
  component: LocationForAccountDetail,
  meta: {
    title: 'Demande de location pour compte',
    requiresAuth: true,
    authorizations: ['location-for-account_show', 'desktop_access']
  }
}]

export default LocationForAccountRouter



// WEBPACK FOOTER //
// ./src/components/LocationForAccount/router.js